import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';

import FeedbackError from 'components/FeedbackError/component';

const enhance = compose(
  withTranslation('Feedback'),
  connect(
    (state) => ({
      mail: settingsSelectors.getOpsMail(state),
    }),
    {}
  )
);

export default enhance(FeedbackError);
